import { useEffect } from 'react';

import { PermissionType } from 'api/types/entity';
import { FormFooter, FormFooterCancel } from 'components';
import { useTranslation } from 'libs/i18n';
import { PermissionWrapper } from 'libs/permissions';

import { Submit, useFormContext } from '../../forms/orderForm';
import { useToggleEditable } from '../../hooks/useToggleEditable';

export interface OrderFormFooterProps {
  submitLoading: boolean | undefined;
}

export const OrderFormFooter = ({ submitLoading }: OrderFormFooterProps) => {
  const { t } = useTranslation();
  const { readOnly, dirty, submitDisabled, resetForm } = useFormContext();

  const editable = !readOnly;

  const { disableEditable } = useToggleEditable();

  useEffect(() => {
    resetForm();
  }, [readOnly, resetForm]);

  return (
    <FormFooter visible={editable}>
      <FormFooterCancel onClick={disableEditable} />
      <PermissionWrapper
        permissions={[
          PermissionType.Order_UpdateSignedOne,
          PermissionType.Order_UpdateUnsignedOne,
        ]}
        type="or"
      >
        <Submit
          disabled={submitDisabled || !dirty}
          label={t('common.save')}
          loading={submitLoading}
          sizeVariant="m"
        />
      </PermissionWrapper>
    </FormFooter>
  );
};
